export const ACTION_SHEET_ALTERNATIVE_MEDICATION = 'alternativeMedication';
export const ACTION_SHEET_CART_UPDATED = 'cartUpdated';
export const ACTION_SHEET_CLARIFICATION = 'clarification';
export const ACTION_SHEET_CONTACT_VERIFICATION = 'contactVerification';
export const ACTION_SHEET_FERTILITY_QUANTITY = 'fertilityQuantity';
export const ACTION_SHEET_NEXT_AVAILABLE_DATE = 'nextAvailableDate';
export const ACTION_SHEET_NOT_COVERED_BY_INSURANCE = 'notCoveredByInsurance';
export const ACTION_SHEET_PRIOR_AUTHORIZATION = 'priorAuthorization';

export type ActionSheetKey =
  | typeof ACTION_SHEET_ALTERNATIVE_MEDICATION
  | typeof ACTION_SHEET_CART_UPDATED
  | typeof ACTION_SHEET_CLARIFICATION
  | typeof ACTION_SHEET_CONTACT_VERIFICATION
  | typeof ACTION_SHEET_FERTILITY_QUANTITY
  | typeof ACTION_SHEET_NEXT_AVAILABLE_DATE
  | typeof ACTION_SHEET_NOT_COVERED_BY_INSURANCE
  | typeof ACTION_SHEET_PRIOR_AUTHORIZATION;

export const getActionSheetKey: (arg0: any) => ActionSheetKey | null | undefined = (state) => state.ui.actionSheet.key;

export const getActionSheetProps: (arg0: any) => Record<string, any> | null | undefined = (state) =>
  state.ui.actionSheet.props;

export type ShowActionSheetPayload = {
  key: ActionSheetKey;
  props?: Record<string, unknown>;
};

export const SHOW_ACTION_SHEET = 'SHOW_ACTION_SHEET';

export type ActionShowActionSheet = {
  type: typeof SHOW_ACTION_SHEET;
  payload: ShowActionSheetPayload;
};

export function showActionSheet(payload: ShowActionSheetPayload) {
  return {
    type: SHOW_ACTION_SHEET,
    payload,
  };
}

export const HIDE_ACTION_SHEET = 'HIDE_ACTION_SHEET';

export type ActionHideActionSheet = {
  type: typeof HIDE_ACTION_SHEET;
};

export function hideActionSheet() {
  return {
    type: HIDE_ACTION_SHEET,
  };
}
